import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import useScreenSize from "../../Hooks/useScreenSize";

import { GET_DOCUMENT_TYPES } from "../../Graphql/queries/queryGetDocumentTypes";
import { GET_STATE_BY_COUNTRY } from "../../Graphql/queries/queryGetStateByCountry";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { MUTATION_CREATE_HEALTH_AFFILIATION } from "../../Graphql/mutations/mutationCreateHealthAffiliation";
import { RoutesNames } from "../../components/utils/routes";
import { useToastError } from "../../Hooks/useToastError";
import { useToastInfo } from "../../Hooks/useToastInfo";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { validationAffiliationToHealth } from "../../components/validations/validationAffiliationToHealth";
import { Variables } from "../../styles/Variables";
import AffiliationToHealthForm from "../../components/form/AffiliationToHealthForm";
import IconBack from "../../components/Icons/IconBack";
import IconInfoYellow from "../../components/Icons/IconInfoYellow";
import IconPlay from "../../components/Icons/IconPlay";
import ModalInformation from "../../Modals/ModalInformation";
import ModalOldQuestion from "../../Modals/ModalOldQuestion";
import ModalTermsConditions from "../../Modals/ModalTermAndConditions/ModalTermsConditions";
import ModalVideo from "../../Modals/ModalVideo";

import {
  ContainerBack,
  ContainerGlobal,
  ContainerOptions,
  ContainerReverse,
  ContainerStep,
  ContainerTextBold,
  ContainerVideoAndInfo,
  ContainText,
  ContentForms,
  DataCenter,
  Footer,
  Header,
  ImageTable,
  InfoTexts,
  TextBack,
  TextBar,
  TextBold,
  TextH3,
  TextInformative,
  TextOptions,
  TextStep,
  TextStepOrange,
  TitleSisben,
  TopText,
} from "../../styles/PageStyles/Health/StylesAffiliateHealthForm";

const AffiliateHealthForm = () => {
  const router = useNavigate();
  /* eslint-disable */
  const SISBEN_VIDEO = process.env.REACT_APP_SISBEN_VIDEO;
  const SISBEN_FORM = process.env.REACT_APP_SISBEN_FORM;
  const TERMS_DATA_PERSON_ID = process.env.REACT_APP_TERMS_DATA_PERSON_ID;
  const SITE_KEY = process.env.REACT_APP_SITE;
  /* eslint-enable */
  const { width } = useScreenSize();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalInformation, setModalInformation] = useState(false);
  const [showVideoExplication, setShowVideoExplication] = useState(false);
  const [terms, setTerms] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [file, setFiles] = useState(null);
  const [typeDocument, setTypeDocument] = useState("");
  const [adultInfo, setAdultInfo] = useState({
    name: null,
    lastNames: null,
    documentT: null,
    documentNumber: null,
    numberPhone: null,
    terms: null,
  });
  const [modalOld, setModalOld] = useState(true);
  const [old, setOld] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [location, setLocation] = useState({
    state: "",
    city: "",
    eps: "",
  });
  const [pickers, setPickers] = useState({
    gender: "",
    dependentChildren: null,
  });
  const [dataCreate, setDataCreate] = useState({
    values: {},
    resetForm: null,
  });
  const toastSuccessful = useToastSuccessful();
  const toastInfo = useToastInfo();

  const { error, data, loading } = useQuery(GET_STATE_BY_COUNTRY);
  const { error: error2, data: data2, loading: loading2 } = useQuery(GET_DOCUMENT_TYPES);

  const [createAffiliationHealth, { error: errorMutation, loading: loadingMutation }] = useMutation(
    MUTATION_CREATE_HEALTH_AFFILIATION,
    {
      onCompleted: (e) => {
        setTimeout(() => {
          toastSuccessful(e.createHealthAffiliation.message);
          router(RoutesNames.home);
        }, 2000);
      },
      onError: (err) => console.error(err),
    },
  );

  useToastLoading(loadingMutation);
  useToastError(error || error2 || errorMutation);

  const onHandleBack = () => {
    router(RoutesNames.optionsHealth);
  };

  const onHandleSubmit = (values, { resetForm }) => {
    if (typeDocument === "") {
      return toastInfo("Debe seleccionar un tipo de documento.");
    }
    if (file === null) {
      return toastInfo("Debe cargar su documento de identidad.");
    }
    if (location.state === "" || location.city === "" || location.eps === "") {
      return toastInfo("Debe seleccionar un departamento, un municipio y una EPS.");
    }
    if (pickers.gender === "") {
      return toastInfo("Debe seleccionar un sexo.");
    }
    if (pickers.dependentChildren === null) {
      return toastInfo("Tiene o no personas a cargo.");
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: "submit" }).then((token) => {
        setCaptcha(token);
      });
    });
    if (values.phoneNumber.length !== 7 && values.phoneNumber.length !== 10) {
      return toastInfo("Los números de teléfono deben tener 7 o 10 números.");
    }
    if (values.secondaryPhoneNumber.length !== 7 && values.secondaryPhoneNumber.length !== 10) {
      return toastInfo("Los números de teléfono deben tener 7 o 10 números.");
    }
    setDataCreate({ values, resetForm });
    setModalVisible(true);
  };

  const onHandleAccept = () => {
    setModalVisible(false);
    createAffiliationHealth({
      variables: {
        documentNumber: dataCreate.values.documentNumber,
        documentTypeId: typeDocument,
        documentExpirationDate: `${dataCreate.values.documentExpirationDate}T05:00:00.0000Z`,
        email: dataCreate.values.email,
        stateId: parseInt(location.state),
        cityId: location.city,
        epsId: parseInt(location.eps),
        gender: pickers.gender,
        birthDate: `${dataCreate.values.birthday}T05:00:00.0000Z`,
        dependentChildren: pickers.dependentChildren === "true",
        firstName: dataCreate.values.name,
        lastName: dataCreate.values.lastName,
        phoneNumber: dataCreate.values.phoneNumber,
        secondaryPhoneNumber: dataCreate.values.secondaryPhoneNumber,
        neighborhood: dataCreate.values.neighborhood,
        termsAndConditionsAcceptedId: terms,
        files: file,
        token: captcha,
        older: old,
        optionalPhoneNumber: dataCreate.values.whatsAppPhoneNumber,
        termsAndConditionAdultAcceptedId: adultInfo.terms,
        documentAdultTypeId: adultInfo.documentT,
        firstNameAdult: adultInfo.name,
        lastNameAdult: adultInfo.lastNames,
        phoneNumberAdult: adultInfo.numberPhone,
        documentNumberAdult: adultInfo.documentNumber,
      },
    });
    // dataCreate.resetForm()
  };

  if (loading || loading2) return <LoadingScreen />;

  const states = data?.getStateByCountry.data;
  const documentTypes = data2?.getDocumentTypes.data;

  return (
    <ContainerGlobal style={{ height: "auto" }}>
      <ContentForms>
        <ContainerReverse>
          <TopText>
            Este portal pretende únicamente ayudar a gestionar los trámites, por lo que los tiempos, aceptación,
            negación, y gestión depende exclusivamente de las entidades encargadas.
          </TopText>
          <Header>
            <ContainerStep>
              <TextStep>
                Este proceso lo podrás realizar <TextStepOrange>ÚNICAMENTE</TextStepOrange> si tu lugar de residencia es
                en algún Municipio del Departamento de Antioquia.
              </TextStep>
            </ContainerStep>
            <ContainerVideoAndInfo>
              <ContainerOptions onClick={() => setShowVideoExplication(true)}>
                <IconPlay width={width < 1199 && 30} height={width < 1199 && 30} />
                <TextOptions>Video explicativo</TextOptions>
              </ContainerOptions>
              <ContainerOptions onClick={() => setModalInformation(true)}>
                <IconInfoYellow width={width < 1199 && 20} height={width < 1199 && 20} />
                <TextOptions>Nota informativa</TextOptions>
              </ContainerOptions>
            </ContainerVideoAndInfo>
            <ContainerBack onClick={onHandleBack}>
              <IconBack width={width < 1199 && 23} height={width < 1199 && 16} />
              <TextBack>Atrás</TextBack>
            </ContainerBack>
            <ModalVideo modalOpen={showVideoExplication} setModalOpen={setShowVideoExplication} />
            <ModalInformation modalOpen={modalInformation} setModalOpen={setModalInformation} moreInfo>
              <TextInformative>
                Recuerda: para este trámite debes tener el documento de identidad a la mano.
              </TextInformative>
              <ImageTable src="/information-types-document.png" />
            </ModalInformation>
          </Header>
        </ContainerReverse>
        <DataCenter>
          <ContainText>
            <TextBar>AFILIACIÓN A LA SALUD</TextBar>
          </ContainText>
          <ContainerTextBold>
            <TextBold>
              *Esta opción por ahora <TextH3>SOLO</TextH3> aplica para el régimen <TextH3>subsidiado</TextH3>, quiere
              decir, para las personas que <TextH3>NO</TextH3> tienen ingresos o empleo, no tienen capacidad de{" "}
              <TextH3>pago</TextH3>.
            </TextBold>
            <TextBold>
              *Si eres empleado, tu empleador deberá realizar los trámites correspondientes ante la entidad encargada o
              si eres trabajador independiente lo deberás hacer tú directamente.
            </TextBold>
          </ContainerTextBold>
          <AffiliationToHealthForm
            handleSubmit={onHandleSubmit}
            dataState={states || []}
            dataDocumentType={documentTypes || []}
            setLocation={setLocation}
            setPickers={setPickers}
            setDocument={setTypeDocument}
            validationSchema={validationAffiliationToHealth}
            color={Variables.colorPrimary}
            file={file}
            setFile={setFiles}
            setAdultInfo={setAdultInfo}
            old={old}
          ></AffiliationToHealthForm>
          <Footer />
        </DataCenter>
      </ContentForms>
      <ModalInformation modalOpen={showInfo} setModalOpen={setShowInfo} close={RoutesNames.home}>
        <TitleSisben>El registro fue exitoso.</TitleSisben>
        <InfoTexts>EL siguiente paso sera llenar la encuesta de Sisbén.</InfoTexts>
        <InfoTexts>
          Link con video de explicación para llenar debidamente la encuesta...{" "}
          <span>
            <textsA href={SISBEN_VIDEO} target="_blank">
              Aquí
            </textsA>
          </span>
        </InfoTexts>
        <InfoTexts>
          Puedes llenar el cuestionario desde{" "}
          <span>
            <textsA href={SISBEN_FORM}>Aquí</textsA>
          </span>
        </InfoTexts>
      </ModalInformation>
      <ModalOldQuestion
        modalOpen={modalOld}
        pressYes={() => {
          setOld(true);
          setModalOld(false);
        }}
        pressNo={() => {
          setOld(false);
          setModalOld(false);
        }}
      />
      <ModalTermsConditions
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        press={onHandleAccept}
        setTerms={setTerms}
        idTermsAndConditions={TERMS_DATA_PERSON_ID}
      />
    </ContainerGlobal>
  );
};

export default AffiliateHealthForm;
